import { render, staticRenderFns } from "./CampaignLightLeversForm.vue?vue&type=template&id=64da8c92&"
import script from "./CampaignLightLeversForm.vue?vue&type=script&lang=ts&"
export * from "./CampaignLightLeversForm.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignLightLeversForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports